import React from 'react'

const Header = () => {
  return (
    <div className='header'>
        <div>
            <h2>"QISHLOQ XO‘JALIGINI MEXANIZATSIYALASH" fakulteti</h2>
            <h2>"TRAKTORLAR VA AVTOMOBILLAR" kafedrasi</h2>
        </div>
    </div>
  )
}

export default Header